import {Address} from '@store/common/address.model';
import {
  ClientOrganisationActiveStat,
  ContactType,
  Currency,
  Domain,
  OrganisationKind,
  OrganisationLanguage,
  PaymentTerm,
  TaxRule
} from '@store/common/organisation.enums';
import {FacturationMode} from '@store/clients/details/facturationMode/facturation-mode.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import I18n from '@utils/i18n.utils';
import {SelectItem} from '@components/inputs/select/Select.component';
import {UserLight} from '@store/settings/users';

export enum InvoicingSource {
  NESSY = 'NESSY',
  MOS = 'MOS',
  NONE = 'NONE'
}

export namespace InvoicingSource {

  export const selectItems = () =>
    [InvoicingSource.NESSY, InvoicingSource.MOS, InvoicingSource.NONE].map((it) => ({
      label: getLabel(it),
      value: it,
    }));


  export const getLabel = (source?: InvoicingSource): string => {
    switch (source) {
      case InvoicingSource.NESSY:
        return I18n.t('global.invoicingSource.NESSY');
      case InvoicingSource.MOS:
        return I18n.t('global.invoicingSource.MOS');
      case InvoicingSource.NONE:
        return I18n.t('global.invoicingSource.NONE');
      default:
        return I18n.t('global.invoicingSource.NONE');
    }
  };

  export const getColor = (source?: InvoicingSource): 'warning' | 'success' | 'secondary' => {
    switch (source) {
      case InvoicingSource.NESSY:
        return 'warning';
      case InvoicingSource.MOS:
        return 'success';
      case InvoicingSource.NONE:
        return 'secondary';
      default:
        return 'secondary';
    }
  };
}

export enum ManageContactType {
  ORGANISATION = 'ORGANISATION',
  ORGANISATION_UNIT = 'ORGANISATION_UNIT',
}

export interface ManageContact {
  id?: number;
  title?: string;
  contactRole?: ContactType;
  surName?: string;
  name?: string;
  phone?: string;
  email?: string;
  comment?: string;
  address?: Address;
}

export interface OrganisationUnitLight {
  id: number;
  name: string;
  address?: Address;
  supplierOrganisation?: OrganisationLight;
}

export interface OrganisationLight {
  id: number;
  name: string;
  outTaxRule?: TaxRule;
}

export interface ManageOrganisationUnit {
  id?: number;
  status?: GlobalStatus;
  name?: string;
  address?: Partial<Address>;
  rcNumber?: string;
  unitKinds?: OrganisationKind[];
  region?: string;
  phone?: string;
  fax?: string;
  email?: string;
  domains?: Domain[];
  closingDays?: string[];

  clientOrganisationUnitContacts?: ManageContact[];
  supplierOrganisationUnitContacts?: ManageContact[];

  facturationMode?: FacturationMode;

  invoicingAdditionalInformation?: string;

  isGenericUnit?: boolean;
}

export interface ManageOrganisation {
  id?: number;
  name?: string;
  email?: string;
  organisationKinds?: OrganisationKind[];
  status?: GlobalStatus;
  commercialName?: string;
  rcNumber?: string;
  address?: Partial<Address>;
  closingDays?: string[];
  isClientOrSupplierToo?: boolean;
  region?: string;
  phone?: string;
  fax?: string;
  webSite?: string;
  domains?: Domain[];
  enabledStats?: ClientOrganisationActiveStat[];
  defaultLanguage?: OrganisationLanguage;
  currency?: Currency;
  companyIde?: string;
  inTaxRule?: TaxRule;
  outTaxRule?: TaxRule;
  inPaymentTermsNumDays?: PaymentTerm;
  outPaymentTermsNumDays?: PaymentTerm;
  inBillingToOrganisation?: {
    id: number;
    name: string;
  };
  iban?: string;
  users?: any[];
  clientOrganisationContacts?: ManageContact[];
  supplierOrganisationContacts?: ManageContact[];
  logoPictureDocumentId?: number;
  invoicingAdditionalInformation?: string;
  invoicingSource?: InvoicingSource;
  billingManager?: UserLight;
  selectedBillingManager?: SelectItem;
}

